/** Maps our locale codes to BCP 47 language tags (mirrors formatDate.ts). */
const LOCALE_BCP47_MAP: Record<string, string> = {
  en: 'en-GB',
  de: 'de-DE',
  bg: 'bg-BG',
};

/**
 * Format a year + 1-indexed month as a localised heading string.
 * e.g. formatMonthHeading(2026, 4, 'en') → "April 2026"
 *
 * Uses Intl.DateTimeFormat with { month: 'long', year: 'numeric' }.
 */
export const formatMonthHeading = (year: number, month: number, locale: string): string => {
  const bcp47 = LOCALE_BCP47_MAP[locale] ?? 'en-GB';
  const date = new Date(year, month - 1, 1);
  return new Intl.DateTimeFormat(bcp47, { month: 'long', year: 'numeric' }).format(date);
};

/**
 * Return an array of 7 Monday-first abbreviated weekday names for the given locale.
 * e.g. getWeekdayAbbreviations('en') → ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
 *
 * Anchored to the week of 2 Jan 2023 (a Monday).
 */
export const getWeekdayAbbreviations = (locale: string): string[] => {
  const bcp47 = LOCALE_BCP47_MAP[locale] ?? 'en-GB';
  const formatter = new Intl.DateTimeFormat(bcp47, { weekday: 'short' });
  // Week anchored to Mon 2 Jan 2023
  return Array.from({ length: 7 }, (_, i) =>
    formatter.format(new Date(2023, 0, 2 + i)),
  );
};
